var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2841 14.5564L17.9843 14.2876L17.9843 14.2876L17.2841 14.5564ZM6 20.25H5.25V21.75H6V20.25ZM22 21.75H22.75V20.25H22V21.75ZM14.4668 7.21617L13.7666 7.48493L14.4668 7.21617ZM9.93549 18.6825L11.4161 14.8251L10.0157 14.2876L8.5351 18.145L9.93549 18.6825ZM11.4161 14.8251L14.2334 7.48493L12.833 6.94742L10.0157 14.2876L11.4161 14.8251ZM13.7666 7.48493L16.5839 14.8251L17.9843 14.2876L15.167 6.94742L13.7666 7.48493ZM16.5839 14.8251L18.0645 18.6825L19.4649 18.145L17.9843 14.2876L16.5839 14.8251ZM10.7159 15.3064H17.2841V13.8064H10.7159V15.3064ZM6 21.75H22V20.25H6V21.75ZM14.2334 7.48493C14.1513 7.69882 13.8487 7.69881 13.7666 7.48493L15.167 6.94742C14.7565 5.87798 13.2435 5.87798 12.833 6.94742L14.2334 7.48493Z",
    fill: "#FFFFFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhite);
export default __webpack_public_path__ + "static/media/icon-white.894263b4b6b5b298d385352095030915.svg";
export { ForwardRef as ReactComponent };